export default __webpack_public_path__ + "static/media/AllProductItems8.f2963bae.png";